import React from 'react';
import { ReferralRequest } from '../../services/referrals.service';
import './ChatInterface.css';

interface ChatInterfaceProps {
  request: ReferralRequest;
  employeeId: string;
  employeeName: string;
  onClose: () => void;
  darkMode?: boolean;
}

const ChatInterface: React.FC<ChatInterfaceProps> = ({ 
  request, 
  employeeId,
  employeeName,
  onClose,
  darkMode = false 
}) => {
  // Show coming soon state for now
  return (
    <div className={`chat-interface ${darkMode ? 'dark' : 'light'} coming-soon`}>
      <div className="chat-header">
        <div className="chat-user-info">
          <img 
            src={request.candidateAvatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${request.candidateEmail}`}
            alt={request.candidateName}
            className="chat-user-avatar"
          />
          <div className="chat-user-details">
            <h3>{request.candidateName}</h3>
            <p>{request.candidateTitle}</p>
          </div>
        </div>
        <button className="chat-close-btn" onClick={onClose}>
          <span className="material-icons">close</span>
        </button>
      </div>
      
      <div className="chat-coming-soon">
        <div className="coming-soon-icon">
          <span className="material-icons" style={{ fontSize: '80px' }}>chat</span>
        </div>
        <h2>Chat Feature Coming Soon</h2>
        <p>Real-time messaging between employees and candidates will be available soon!</p>
        <div className="feature-preview">
          <h4>Upcoming Features:</h4>
          <ul>
            <li>Real-time messaging with typing indicators</li>
            <li>File and document sharing</li>
            <li>Interview scheduling integration</li>
            <li>Message history and search</li>
            <li>Mobile app support</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ChatInterface;